import './bootstrap';
import './utils';

import * as TimeUtils from './utils/Time';

import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect'
import {
    accordion,
    calendarSelector,
    checkboxGroup,
    dayMonthInput,
    dualListbox,
    fileModalUploader,
    fileUploader,
    inputTag,
    monthInput,
    tabSelector,
    textEditor,
    toast,
    toastManager,
    weekInput,
    simpleLoader,
    select,
    carousel,
    audioPlayer
} from './alpine-components'

import {
    vsprompt_view,
    module_settings_view,
    create_audio_view,
    edit_audio_view,
    guion_view_component
} from './views';

Alpine.data('checkboxGroup', checkboxGroup);
Alpine.data('file_uploader_component', fileUploader);
Alpine.data('accordion', accordion);
Alpine.data('tab_selector_component', tabSelector);
Alpine.data('file_modal_uploader_component', fileModalUploader);
Alpine.data('week_input_component', weekInput);
Alpine.data('month_input_component', monthInput);
Alpine.data('day_month_input_component', dayMonthInput);
Alpine.data('dual_listbox_component', dualListbox);
Alpine.data('calendar_selector_component', calendarSelector);
Alpine.data('input_tag', inputTag);
Alpine.data('text_editor_component', textEditor);
Alpine.data('toast_manager_component', toastManager);
Alpine.data('toast_component', toast);
Alpine.data('select_component', select);
Alpine.data('carousel_component', carousel);
Alpine.data('audio_player_component', audioPlayer);

//* Loaders
Alpine.data('simple_loader_component', simpleLoader);

// Views Alpine components
Alpine.data('vsprompt_view', vsprompt_view);
Alpine.data('module_settings_view', module_settings_view);
Alpine.data('create_audio_view', create_audio_view);
Alpine.data('edit_audio_view', edit_audio_view);
Alpine.data('guion_view_component', guion_view_component);

window.Alpine = Alpine;
window.anime = anime;
window.TimeUtils = TimeUtils;

Alpine.plugin(intersect);
Alpine.start();

if (document.getElementById('vue-root')) {
    import('./vue-entry')
}
